// Google Analytics 4 イベントトラッキングユーティリティ

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * GA4にイベントを送信
 */
export const trackEvent = (
  eventName: string,
  params?: Record<string, string | number | boolean>
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

/**
 * コンバージョンイベント: 店舗登録CTAクリック
 */
export const trackSignupClick = (source: string) => {
  trackEvent('signup_click', {
    event_category: 'conversion',
    event_label: source,
    source: source,
  });
};

/**
 * コンバージョンイベント: 店舗登録完了
 */
export const trackSignupComplete = () => {
  trackEvent('signup_complete', {
    event_category: 'conversion',
  });
};

/**
 * コンバージョンイベント: 店舗登録ページ表示 (Google広告コンバージョン)
 */
export const trackSignupPageView = () => {
  trackEvent('conversion_event_signup', {});
};

/**
 * イベント: 機能ページへのリンククリック
 */
export const trackFeaturesClick = (source: string) => {
  trackEvent('features_click', {
    event_category: 'engagement',
    source: source,
  });
};

/**
 * イベント: ニュース記事閲覧
 */
export const trackNewsView = (slug: string, title: string) => {
  trackEvent('news_view', {
    event_category: 'content',
    article_slug: slug,
    article_title: title,
  });
};
